/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Sign_UpInputs */

const en_common_auth_gate_sign_up = /** @type {(inputs: Common_Auth_Gate_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create free account`)
};

const zh_common_auth_gate_sign_up = /** @type {(inputs: Common_Auth_Gate_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费注册`)
};

/**
* | output |
* | --- |
* | "Create free account" |
*
* @param {Common_Auth_Gate_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_sign_up = /** @type {((inputs?: Common_Auth_Gate_Sign_UpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Sign_UpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_sign_up(inputs)
	return zh_common_auth_gate_sign_up(inputs)
});
export { common_auth_gate_sign_up as "common.auth.gate.sign_up" }